import { Game } from '../../games.model';

export interface BaseLayoutProps {
  games: Game[];
  disabled?: boolean;
  showGameName?: boolean;
  fallbackImageAltText?: string;
  fallbackImageUrl?: string;
  onViewGameInfo?: (game: Game) => void;
  onPlayDemo?: (game: Game) => void;
  onPlayGame?: (game: Game) => void;
  containerElementWidth?: number;
  getCompositeKey: (game: Game, suffix?: string) => string;
}

export const createCompositeKey = (game: Game, suffix?: string): string => {
  const baseKey = `${game.id || game.gameId}-${game.categoryName || 'default'}`;

  return suffix ? `${baseKey}-${suffix}` : baseKey;
};

export const createSharedLayoutProps = (
  games: Game[],
  disabled: boolean,
  showGameName: boolean,
  fallbackImageAltText: string,
  fallbackImageUrl: string,
  onViewGameInfo?: (game: Game) => void,
  onPlayDemo?: (game: Game) => void,
  onPlayGame?: (game: Game) => void,
  containerElementWidth?: number
): BaseLayoutProps => ({
  games,
  disabled,
  showGameName,
  fallbackImageAltText,
  fallbackImageUrl,
  onViewGameInfo,
  onPlayDemo,
  onPlayGame,
  containerElementWidth,
  getCompositeKey: createCompositeKey,
});
